<template>
  <v-card class="red error">
    <v-card-text>
      <v-btn v-if="canHide" small flat class="btn-close" @click="$emit('hide')">
        <v-icon>{{ hideIcon }}</v-icon>
      </v-btn>
      <v-icon class="hidden-sm-and-down icon-absolute">{{ icon }}</v-icon>
      <v-icon class="hidden-md-and-up">{{ icon }}</v-icon>
      <ul>
        <li v-for="message in messages">{{ message }}</li>
      </ul>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: {
      icon: { default: 'warning' },
      messages: {},
      canHide: { default: false },
      hideIcon: { default: 'close' }
    }
  };
</script>

<style scoped lang="less">
  .error {
    color: #ffffff;
    border-radius: 0;

    .btn-close {
      display: inline;
      position: absolute;
      top: 0;
      right: 0;
      min-width: 0;
    }

    .icon-absolute {
      position: absolute;
      left: 25px;
      top: 0;
      bottom: 0;
    }

    ul {
      @media(min-width: 960px) {
        display: inline-block;
        margin: auto;
        padding: 0 60px;
      }

      li {
        text-align: left;
      }
    }
  }
</style>
